import {Component, Input} from '@angular/core';
import {UtilsService} from '../services/utils';
import {OpenAPIService} from '../services/openapi';

declare let window:any;

const MAX_RESPONSE_LENGTH_FOR_HIGHLIGHT = 100 * 1000;

@Component({
    selector: 'api-response',
    templateUrl: '../views/api-response.pug',
})
export class APIResponseComponent {
  @Input() response;
  @Input() headers;
  @Input() statusCode;
  @Input() isRecipe;

  responseType:string;
  error:string;
  refreshing:boolean;
  responseAlert:any;
  showHeaders:boolean;
  highlightedResponse:string;
  highlightedHeaders:string;
  constructor(private utils:UtilsService, public openapi:OpenAPIService) {}

  ngOnChanges() {
    this.headers = this.headers || [];
    this.setAlert();
    this.setResponseType();
    this.stringifyResponse();
  }

  stringifyResponse() {
    let contentTypeHeader = this.headers.filter(s => s.toLowerCase().indexOf('content-type') === 0)[0] || '';
    let responseString = '';
    if (this.response instanceof Document) {
      responseString = window.WebCodeBeauty.xml((new XMLSerializer()).serializeToString(this.response));
    } else {
      if (typeof this.response === 'object') {
        responseString = JSON.stringify(this.response, null, 2);
      } else {
        responseString = this.response || '';
      }
      if (contentTypeHeader.indexOf('application/json') !== -1) {
        try {
          responseString = JSON.stringify(JSON.parse(responseString), null, 2);
        } catch (e) {
          console.log('invalid JSON:', responseString);
        }
      } else if (contentTypeHeader.indexOf('/xml') !== -1) {
        responseString = window.WebCodeBeauty.xml(responseString);
      }
    }
    this.highlightedHeaders = window.Prism.highlight(this.headers.join('\r\n'), window.Prism.languages.http);
    let highlightLang = '';
    if (contentTypeHeader.indexOf('/xml') !== -1) {
      highlightLang = 'xml';
    } else if (contentTypeHeader.indexOf('/json') !== -1) {
      highlightLang = 'json';
    }
    if (highlightLang && responseString.length < MAX_RESPONSE_LENGTH_FOR_HIGHLIGHT) {
      this.highlightedResponse = window.Prism.highlight(responseString, window.Prism.languages[highlightLang]);
    } else {
      responseString = responseString.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      this.highlightedResponse = responseString;
    }
  }

  setAlert() {
    if (window.checkResponse) {
      this.responseAlert = window.checkResponse(this.response, this.statusCode);
    } else {
      this.responseAlert = {type: 'danger', message: 'Status Code ' + this.statusCode};
      if (this.statusCode >= 200 && this.statusCode < 300) this.responseAlert.type = 'success';
      else if (this.statusCode >= 300 && this.statusCode < 400) this.responseAlert.type = 'warning';
    }
    if (this.isRecipe) {
      if (this.responseAlert.type === 'success') {
        this.responseAlert.message =
              "Success! Review the response below and click the <b>next</b> button above when you're ready to continue.";
      } else {
        this.responseAlert.message =
              "The API returned an error. Please review the response below" +
              " and follow the instructions above to execute this step correctly.<br>" +
              this.responseAlert.message;
      }
    }
  }

  setResponseType() {
    this.responseType = '';
    this.headers.forEach(header => {
      let m = header.match(/content-type:\s*(.*)$/i);
      if (!m) return;
      let contentType = m[1];
      if (contentType.match(/json/)) this.responseType = 'JSON';
      else if (contentType.match(/xml/)) this.responseType = 'XML';
      // TODO: add more content types
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/api-response.ts